import React from 'react';

interface EmptyStateProps {
  title: string;
  message: string;
  icon?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, message, icon = '📭' }) => {
  return (
    <div style={{ 
      padding: '60px 20px', 
      textAlign: 'center', 
      color: '#999' 
    }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>{icon}</div>
      <p style={{ fontSize: '16px', marginBottom: '8px', fontWeight: '500' }}>{title}</p>
      <p style={{ fontSize: '14px' }}>{message}</p>
    </div>
  );
};

export default EmptyState;
